export default "__VITE_ASSET__PKx8juDN__"